import { Route } from "react-router-dom";
import { RentioLegalCaseForm } from "./components/RentioLegalCaseForm";
import { RentioLegal } from "./RentioLegal";

export const getRentioLegalScene = () => (
  <Route path="rentio-legal">
    <Route path="add" element={<RentioLegalCaseForm isEdit={false} />} />

    <Route path="edit" element={<RentioLegalCaseForm isEdit={true} />} />

    <Route index element={<RentioLegal />} />
  </Route>
);
